import React from "react";

const BookingsHeader = () => {
  return (
    <div className="lg:flex items-center justify-between">
      <div className="text-3xl font-rubik font-bold leading-10">
        <h3>Bookings</h3>
      </div>
    </div>
  );
};

export default BookingsHeader;
